import type { Mission } from '../missions.ts'

export const dhs: Mission = {
  id: "dhs",
  name: "U.S. Department of Homeland Security",
  short: "DHS",
  call: "Homeland",
  kind: "department",
  url: "https://www.dhs.gov/",
  established: 2002,
  palette: {
    primary: "#005288",
    secondary: "#0078ae",
    accent: "#5e9732",
  },
  colorSource: {
    kind: "site",
    url: "https://www.dhs.gov/",
  },
  motif: "eagle",
  mission: {
    text: "With honor and integrity, we will safeguard the American people, our homeland, and our values.",
    url: "https://www.dhs.gov/about-dhs",
  },
  fact: {
    text: "DHS was created by combining all or part of 22 different federal departments and agencies into one integrated department.",
    url: "https://www.dhs.gov/creation-department-homeland-security",
  },
  seal: {
    file: "public/seals/dhs.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Homeland_Security.svg",
  },
  identifier: {
    about: "https://www.dhs.gov/about-dhs",
    accessibility: "https://www.dhs.gov/accessibility",
    foia: "https://www.dhs.gov/foia",
    noFear: "https://www.dhs.gov/homeland-security-no-fear-act-reporting",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.dhs.gov/performance-financial-reports",
    privacy: "https://www.dhs.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/dhs-munro-aerial.jpg",
        small: "/media/dhs-munro-aerial-sm.jpg",
        alt: "Aerial view of the terraced, green-roofed Douglas A. Munro Building on the St. Elizabeths campus in southeast Washington, surrounded by trees.",
        title: "Douglas A. Munro Coast Guard Headquarters Building, St. Elizabeths campus, August 21, 2015",
        creator: "Senior Chief Petty Officer Michael Hvozda, U.S. Coast Guard",
        source: "https://commons.wikimedia.org/wiki/File:Douglas_A._Munro_Coast_Guard_Headquarters_Building_-_Image_2_of_7.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/dhs-st-elizabeths.jpg",
        small: "/media/dhs-st-elizabeths-sm.jpg",
        alt: "The red brick Center Building at St. Elizabeths, with its central tower and flagpoles, under a clear blue sky.",
        title: "St. Elizabeths Campus Building 1, DHS headquarters, March 16, 2023",
        creator: "Tia Dufour, U.S. Department of Homeland Security",
        source: "https://commons.wikimedia.org/wiki/File:DHS_St_Elizabeth's_Building_1.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
